import React from "react";
import useApp from "../../../store/contexts/AppContext";
import FormatNumberCounter from "../../../utils/FormatNumberCounter";
import { makeStyles } from "@mui/styles"
import { ActiveChatInRoomStyle } from "./ActiveChatInRoomStyle";

const useStyles = makeStyles((theme) => ActiveChatInRoomStyle(theme));

export default function UserBalance() {
  const classes = useStyles();

  const {
    appState: { userData },
  } = useApp();

  return (
    <div className={classes.balanceContainer}>
      <div
        className={classes.balanceInnerLeft}
        title={userData?.available_coins?.toLocaleString()}
      >
        <b>Coins:</b>{" "}
        <span className={classes.balanceInnerLeftValue}>
          {FormatNumberCounter(userData?.available_coins || 0)}
        </span>
      </div>
      <div className={classes.balanceInnerRight} title={userData?.available_xp?.toLocaleString()}>
        <b>XP:</b>{" "}
        <span className={classes.balanceInnerRightValue}>
          {FormatNumberCounter(userData?.available_xp || 0)}
        </span>
      </div>
    </div>
  );
}
